import { render, staticRenderFns } from "./audioEditor.vue?vue&type=template&id=88ffcd22&scoped=true&"
import script from "./audioEditor.vue?vue&type=script&lang=js&"
export * from "./audioEditor.vue?vue&type=script&lang=js&"
import style0 from "./audioEditor.vue?vue&type=style&index=0&id=88ffcd22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ffcd22",
  null
  
)

export default component.exports